<template>
  <a-card :bordered="false">
    <a-tabs>
      <a-tab-pane key="1" tab="待办事项列表">
        <s-table
          ref="TableA"
          rowKey="id"
          :columns="columnsA"
          :data="loadDataA"
          bordered
        >
          <template slot="serial" slot-scope="value, row, index">
            {{ index + 1 }}
          </template>
          <template slot="actions" slot-scope="value, row">
            <!--<a v-if="new Date() > new Date(row.startTime)" @click="handleUpload(row)">上传</a>-->
            <a
              @click="handleUpload(row)"
              v-if="new Date() > new Date(row.startTime)"
              >上传</a
            >
          </template>
        </s-table>
        <upload ref="upload" @initData="initData" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="已办事项列表">
        <s-table
          ref="TableB"
          rowKey="id"
          :columns="columnsB"
          :data="loadDataB"
          bordered
        >
          <template slot="serial" slot-scope="value, row, index">
            {{ index + 1 }}
          </template>
          <template slot="actions" slot-scope="value, row">
            <a @click="handleDetail(row)">详情</a>
          </template>
        </s-table>
        <detail ref="detail" />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { STable } from "@/components";
import upload from "./modules/upload";
import detail from "./modules/detail";
import { toText } from "@components/_util/util";
import {
  findPage
  // resource
} from "@/api/base/uploadTask/manager";
import moment from "moment";

const columnsA = [
  {
    title: "#",
    width: 70,
    align: "center",
    scopedSlots: { customRender: "serial" }
  },
  {
    title: "任务名称",
    dataIndex: "workerName"
  },
  {
    title: "任务描述",
    ellipsis: true,
    dataIndex: "content",
    customRender: value => {
      return value ? toText(value) : "";
    }
  },
  {
    title: "任务开始时间",
    dataIndex: "startTime",
    customRender: value => {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  {
    title: "任务截止时间",
    dataIndex: "endTime",
    customRender: value => {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  {
    title: "任务状态",
    dataIndex: "status",
    customRender: (value, row) => {
      // if (new Date() > (new Date(row.endTime))) return "已延期";
      if (new Date() > new Date(row.endTime).setHours(23, 59, 59, 999))
        return "已延期";
      return "待提交";
    },
    filters: [
      { text: "已延期", value: "delay" },
      { text: "待提交", value: "normal" }
    ]
  },
  {
    title: "负责人",
    dataIndex: "personName"
  },
  {
    title: "操作",
    scopedSlots: { customRender: "actions" }
  }
];

const columnsB = [
  {
    title: "#",
    width: 70,
    align: "center",
    scopedSlots: { customRender: "serial" }
  },
  {
    title: "任务名称",
    dataIndex: "workerName"
  },
  {
    title: "任务描述",
    ellipsis: true,
    dataIndex: "content",
    customRender: value => {
      return value ? toText(value) : "";
    }
  },
  {
    title: "任务开始时间",
    dataIndex: "startTime"
  },
  {
    title: "任务截止时间",
    dataIndex: "endTime"
  },
  {
    title: "上传时间",
    dataIndex: "uploadTime"
  },
  {
    title: "任务状态",
    customRender: (value, row) => {
      if (new Date(row.uploadTime) > new Date(row.endTime)) return "延期完成";
      return "已完成";
    }
  },
  {
    title: "负责人",
    dataIndex: "personName"
  },
  {
    title: "操作",
    scopedSlots: { customRender: "actions" }
  }
];
export default {
  components: {
    STable,
    upload,
    detail
  },
  data() {
    return {
      columnsA,
      columnsB,
      // 查询参数
      queryParam: {
        sidx: "startTime",
        sord: "desc"
      },
      // 加载数据方法 必须为 Promise 对象
      loadDataA: params => {
        if (params.status) {
          params.status = params.status.join(",");
        } else {
          params.status = "all";
        }
        const requestParameters = Object.assign(params, this.queryParam, {
          comStatus: "N"
        });
        return findPage(requestParameters).then(res => {
          return res.result;
        });
      },
      loadDataB: params => {
        const requestParameters = Object.assign(params, this.queryParam, {
          comStatus: "Y"
        });
        return findPage(requestParameters).then(res => {
          return res.result;
        });
      }
    };
  },
  methods: {
    handleUpload(record) {
      // const param = { workeId: record.workeId };
      // resource(param).then(res => {
      //   this.$set(record, "resource", res.result);
      //   this.$refs.upload.show(record);
      // });
      this.$refs.upload.show(record);
    },
    handleDetail(record) {
      this.$refs.detail.show(record);
    },
    initData() {
      if (this.$refs.TableA) this.$refs.TableA.refresh(true);
      if (this.$refs.TableB) this.$refs.TableB.refresh(true);

      this.$emit("initData");
    }
  }
};
</script>
<style></style>
